import React, { Fragment } from 'react';
import { getKeyValue, has, t } from 'Src/i18n';
import { Card } from 'Components/frameworks/card/Card';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Title } from 'Components/frameworks/title/Title';
import { GreatMembersSimulator } from 'Components/widgets/great-members-simulator/GreatMembersSimulator';
type Props = {
  loyaltyProgramSimulation: LoyaltyProgramSimulation;
};
export const GreatMembersPointsSection = ({ loyaltyProgramSimulation }: Props) => {
  const pushs = Array.from(
    {
      length: 6,
    },
    (_, i) =>
      has(`customerAccount.greatMember.pointsSection.pushs.${i}.label`)
        ? {
            icon: t(`customerAccount.greatMember.pointsSection.pushs.${i}.icon`),
            label: t(`customerAccount.greatMember.pointsSection.pushs.${i}.label`),
            subLabel: t(`customerAccount.greatMember.pointsSection.pushs.${i}.subLabel`),
          }
        : null,
  ).filter(Boolean);
  const articleEnabled = getKeyValue('customerAccount.greatMember.pointsSection.article.enabled');
  const pushsEnabled = getKeyValue('customerAccount.greatMember.pointsSection.pushsEnabled');
  const simulatorEnabled = getKeyValue(
    'customerAccount.greatMember.pointsSection.simulator.enabled',
  );
  return (
    <Fragment>
      {articleEnabled && pushsEnabled && simulatorEnabled && (
        <Title className="mb-40" hLevel={2} theme="title-brand-n0">
          {t('customerAccount.greatMember.pointsSection.title')}
        </Title>
      )}
      <div className="space-y-60">
        {pushsEnabled && Boolean(pushs.length) && (
          <ul className="grid grid-cols-2 gap-y-40 sm:grid-cols-3">
            {pushs.map((push) => (
              <li
                className="flex flex-col items-center justify-center p-20 text-center odd:max-sm:border-r-1 sm:[&:nth-child(3n+2)]:border-x-1"
                key={push.label}
              >
                <Icon className="mb-20" name={push.icon} width="60px" />
                <p className="text-16 font-semibold">{push.label}</p>
                <p className="text-14">{push.subLabel}</p>
              </li>
            ))}
          </ul>
        )}
        {articleEnabled && (
          <Card
            heading={{
              hLevel: 3,
              title: t('customerAccount.greatMember.pointsSection.article.title'),
            }}
            media={{
              url: t('customerAccount.greatMember.pointsSection.article.imageUrl'),
            }}
            text={{
              text: t('customerAccount.greatMember.pointsSection.article.text'),
            }}
          />
        )}
        {simulatorEnabled && (
          <GreatMembersSimulator loyaltyProgramSimulation={loyaltyProgramSimulation} />
        )}
      </div>
    </Fragment>
  );
};
